import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Header } from 'components/common/header/Header';
import { Button } from 'components/common/button/Button';
import './MeetingCreate.css';

const STORAGE_KEY = 'meeting_create_data';

type MeetingType = 'DAY' | 'TRAVEL';

export const MeetingTypeSelect = () => {
    const navigate = useNavigate();

    // sessionStorage 초기화 (새로운 모임 생성 시작)
    useEffect(() => {
        // 이전 데이터 삭제하고 새로 시작
        sessionStorage.removeItem(STORAGE_KEY);
    }, []);

    const [selectedType, setSelectedType] = useState<MeetingType>('DAY');

    const handleNext = () => {
        if (selectedType) {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
                meetingType: selectedType
            }));
            navigate('/meeting/create/step2');
        }
    };

    return (
        <div className="meeting-create-wrapper">
            <Header title="모임 만들기" isSubPage />

            <div className="meeting-create-content">
                {/* Progress Indicator - 3 Steps */}
                <div className="progress-indicator">
                    <div className="progress-step active">1</div>
                    <div className="progress-line"></div>
                    <div className="progress-step">2</div>
                    <div className="progress-line"></div>
                    <div className="progress-step">3</div>
                </div>

                <div className="progress-labels three-steps">
                    <span className="progress-label active">모임 유형</span>
                    <span className="progress-label">모임 정보</span>
                    <span className="progress-label">일정 설정</span>
                </div>

                {/* Title Section */}
                <div className="meeting-create-title-section">
                    <h1 className="meeting-create-title">어떤 모임을 계획하고 계신가요?</h1>
                    <p className="meeting-create-subtitle">모임 유형에 따라 최적화된 기능을 제공해 드릴게요.</p>
                </div>

                {/* Meeting Type Cards */}
                <div className="meeting-type-cards">
                    {/* 당일 모임 */}
                    <button
                        className={`meeting-type-card ${selectedType === 'DAY' ? 'selected' : ''}`}
                        onClick={() => setSelectedType('DAY')}
                    >
                        <div className="type-card-icon">
                            <span className="type-emoji">🍽️</span>
                        </div>
                        <div className="type-card-content">
                            <h3 className="type-card-title">당일 모임</h3>
                            <p className="type-card-description">
                                식사, 카페, 술자리 등<br />
                                하루에 끝나는 간단한 모임
                            </p>
                            <ul className="type-card-features">
                                <li>날짜 & 시간 선택</li>
                                <li>장소 검색 & 공유</li>
                                <li>정산 기능</li>
                            </ul>
                        </div>
                        <div className="type-card-check">
                            {selectedType === 'DAY' && <span>✓</span>}
                        </div>
                    </button>

                    {/* 여행 모임 */}
                    <button
                        className={`meeting-type-card ${selectedType === 'TRAVEL' ? 'selected' : ''}`}
                        onClick={() => setSelectedType('TRAVEL')}
                    >
                        <div className="type-card-icon">
                            <span className="type-emoji">✈️</span>
                        </div>
                        <div className="type-card-content">
                            <h3 className="type-card-title">여행</h3>
                            <p className="type-card-description">
                                1박 이상의 국내/해외 여행<br />
                                함께 일정을 계획하고 공유해요
                            </p>
                            <ul className="type-card-features">
                                <li>여행 기간 설정</li>
                                <li>일자별 일정 계획</li>
                                <li>AI 일정 추천</li>
                                <li>숙소 & 교통 정보</li>
                            </ul>
                        </div>
                        <div className="type-card-check">
                            {selectedType === 'TRAVEL' && <span>✓</span>}
                        </div>
                    </button>
                </div>

                {/* 추가 안내 */}
                <div className="type-info-box">
                    <span className="info-icon">💡</span>
                    <p className="info-text">
                        {selectedType === 'TRAVEL'
                            ? '여행 모임은 일정 추천, 숙소/교통 정보 등 여행에 특화된 기능을 제공합니다.'
                            : selectedType === 'DAY'
                            ? '당일 모임은 빠르고 간편하게 약속을 잡을 수 있어요.'
                            : '모임 유형을 선택하면 해당 유형에 맞는 기능을 안내해 드릴게요.'}
                    </p>
                </div>
            </div>

            {/* Next Button */}
            <div className="meeting-create-footer">
                <Button
                    text="다음으로"
                    disabled={!selectedType}
                    onPress={handleNext}
                />
            </div>
        </div>
    );
};
